import { ReactComponent as Slide2 } from 'assets/images/home-slide-2.svg';
import { ReactComponent as PhotoIcon } from 'assets/images/photoIcon.svg';
import { ReactComponent as MovieIcon } from 'assets/images/movieIcon.svg';
import { ReactComponent as QuestionMark } from 'assets/images/questionMark.svg';
import { Tooltip } from '@grupoboticario/flora-react';

import {
  CardWarningWrapper,
  CardWarningTitle,
  CardWarningList,
  CardWarningPhotoVideo,
  CardWarningTooltip,
} from './styles';

const CardWarning = (): JSX.Element => {
  return (
    <CardWarningWrapper>
      <CardWarningTitle>
        Fique atento aos documentos obrigatórios:{' '}
        <span>SEM ELES NÃO SERÁ POSSÍVEL REALIZAR O AVISO DO SINISTRO!</span>
      </CardWarningTitle>
      <CardWarningList>
        <div>
          <Slide2 />
        </div>
        <div>
          <ul>
            <li>Declaração de inexistência de outros seguros</li>
            <li>Cartão CNPJ</li>
            <li>Comprovante de endereço do local da ocorrência</li>
            <li>Comprovante de dados bancários</li>
          </ul>
        </div>
      </CardWarningList>
      <CardWarningPhotoVideo>
        <div className="CardWarning-photoVideoBlock">
          <PhotoIcon />
          <div>
            <span>IMAGENS/FOTOS</span> <br />
            Somente serão aceitos arquivos no formato: jpg, png, pdf, xls.
            Tamanho máximo 10mb.
          </div>
        </div>
        <hr />
        <div className="CardWarning-photoVideoBlock">
          <MovieIcon />
          <div>
            <span>FILMAGENS/VÍDEOS</span> <br />
            Somente serão aceitos arquivos no formato: avi, wmv e mp4. <br />
            Tamanho máximo 100mb.
          </div>
        </div>
        <CardWarningTooltip>
          <Tooltip
            icon={<QuestionMark />}
            align="center"
            direction="top"
            text="Antes de anexar o documento, é muito importante verificar a qualidade da imagem e se todas as informações estão legíveis."
          >
            <QuestionMark />
          </Tooltip>
        </CardWarningTooltip>
      </CardWarningPhotoVideo>
    </CardWarningWrapper>
  );
};

export default CardWarning;
